import React, { useContext } from "react";
import {
  Box,
  Grid,
  Typography,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import IconWithProgress from "./IconWithProgress";
import Text from "./Text";
import { SECTIONS } from "../../../config/config";
import { ProcessContext } from "../../../contexts/ProcessContext";

export default function WelcomeWizardProgressStep({
  stepIndex,
  currentProgressStepIndex,
  icon,
  currentSectionProgress,
  section,
  currentSection,
}) {
  const {
    state: { sectionsArray },
  } = useContext(ProcessContext);
  const theme = useTheme();
  const isScreenXs = useMediaQuery(useTheme().breakpoints.down("xs"));

  const isThisStepAheadOfCurrentStep = stepIndex > currentProgressStepIndex;
  const isCurrentSectionEmpty = !currentSection;
  const isThisSectionCurrentSection = section === currentSection?.id;
  const isThisTheLastStep = stepIndex === sectionsArray?.length - 1;

  const progress = Number(currentSectionProgress?.slice(0, -1));
  const boxStyle = {
    opacity:
      isCurrentSectionEmpty ||
      isThisSectionCurrentSection ||
      isThisStepAheadOfCurrentStep
        ? "100%"
        : "30%",
  };
  return (
    <>
      <Box container="true" style={boxStyle}>
        <Grid container display={"flex"} alignItems={"center"}>
          <Grid
            item
            xs={3}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              padding:
                isThisTheLastStep && !isScreenXs
                  ? "0px 8px 0px 8px"
                  : "8x 8px 0px 8px",
            }}
          >
            <IconWithProgress
              icon={icon}
              progress={isThisSectionCurrentSection ? progress : 100}
              currentSection={section}
              isThisSectionCurrentSection={isThisSectionCurrentSection}
            />
            {!isThisTheLastStep && (
              <Box
                style={{
                  borderRight: "3px solid",
                  color: theme.palette.grey[300],
                  height: isScreenXs ? theme.spacing(2) : theme.spacing(3),
                  marginBlock: isScreenXs ? 2 : 4,
                }}
              />
            )}
          </Grid>
          <Grid
            item
            xs={7}
            style={{
              textAlign: "left",
              alignSelf: "flex-start",
              paddingTop: 5,
            }}
          >
            <Typography
              variant={"subtitle1"}
              style={{
                color: theme.palette.info.main,
                lineHeight: 1,
                paddingBottom: 5,
              }}
            >
              <Text tId={SECTIONS[section].id} />
            </Typography>
            <Typography
              variant={"subtitle1"}
              style={{ color: theme.palette.text.title, lineHeight: 1.15 }}
            >
              <strong>
                <Text tId={SECTIONS[section].description} />
              </strong>
            </Typography>
          </Grid>
          <Grid item xs={2}>
            {isThisSectionCurrentSection && (
              <i
                className="material-icons-outlined"
                style={{ color: theme.palette.info.main }}
              >
                tour
              </i>
            )}
          </Grid>
        </Grid>
      </Box>
    </>
  );
}
